export const FETCH_QUOTE_PAGE = "fetchQuotePage";
